<template>
  <div>
    <van-pull-refresh v-model="is_refresh" @refresh="onRefresh">
      <van-list v-model="is_loading"
                :finished="is_load_finished"
                :immediate-check="false"
                finished-text="没有更多了"
                :error.sync="is_error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
        <van-cell v-for="(item, index) in list" :key="item.project_id">
          <div style="display: flex;flex-display:row;justify-content: space-between;align-items: center;width: ">
            <div style="color: #2e2e2e;font-size: 14px">
              <div class="van-multi-ellipsis--l2">{{item.des}}</div>
              <div style="font-size: 12px;color: #999">{{item.create_time}}</div>
            </div>
            <div style="margin-left: 30px" :style="{color:item.amount>=0?'red':'#1aad19'}">{{item.amount | amount}}</div>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
    export default {
        name: 'chargelist',
        filters:{
            amount($value){
              if($value<0)
                return $value
              else
                return "+" + $value
            }
        },
        data() {
            return {
                page: 0,
                list: [],
                is_error: false,
                is_refresh: false,
                is_loading: false,
                is_load_finished: false,
                is_cancel:false
            }
        },
        created: function () {
            this.page = 1;
            this.getData(this.page, false)
        },
        mounted:function(){

        },
        methods: {
            onRefresh() {
                this.select_value = '';
                this.page = 1;
                this.is_load_finished = false;
                this.getData(this.page, true)
            },
            onLoad() {
                this.page++;
                this.getData(this.page, false);

            },
            getData: function (page, refresh) {
                let that = this;
                this.weapi.request({
                    url: 'charge_list',
                    method: 'get',
                    params: {page:page},
                }).then(res => {
                    if (res.data.code === '200') {
                      console.log(res)
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.list = [];
                            that.$toast('刷新成功！');
                            that.is_refresh = false;
                        }
                        if (that.page <= 1) {
                            that.list = [];
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.is_load_finished = true;
                        }
                    }
                    else {
                        that.is_refresh = false;
                        that.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.is_refresh = false;
                    that.is_error = true;
                }).finally(function (response) {
                    that.is_loading = false;
                })
            },
        }
    }
</script>
<style>

  .my-swipe .van-swipe-item {
    color: #fff;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }

  .my-swipe .swipe-img {
    width: 100%;
  }

  .article-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

  }
  .article-wrap .game-over{
    position: absolute;
    right: 10px;
  }
  .article-content-wrap{
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  .tongji-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-right: 20px;
  }
  .tongji-wrap span{
    margin-left: 5px;
  }
  /*.van-list{*/
    /*margin:10px;*/
    /*border-radius: 4px;*/
  /*}*/
</style>
